import { Component } from '@angular/core';
import { getImgeUrl } from 'src/environments/environment';
import { CommonModule, NgFor } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { AdminService } from 'src/app/admin/admin.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { PaginationComponent } from 'src/app/admin/pagination/pagination.component';
import { ThemeCustomizerService } from 'src/app/components/common/theme-customizer/theme-customizer.service';


@Component({
  selector: 'app-blog-list',
  standalone: true,
  imports: [NgFor, RouterModule, ReactiveFormsModule, PaginationComponent, CommonModule],
  templateUrl: './blog-list.component.html',
  styleUrl: './blog-list.component.scss'
})
export class BlogListComponent {

  blogs
  filter_form: FormGroup
  language = 1
  languages:any
  page = 1
  number_of_page = 1
  paginatedData: any[];
  currentPage: number = 1;
  itemsPerPage: number = 10;
  totalItems: number;
  totalPages
  imageUrl = getImgeUrl()
  filter:any = {
    "title": "", 
    "author": "",
    "page": 1, 
    "lang": this.language
  }
  isToggled = false;

  constructor(
    private adminService: AdminService,
    private formBuilder: FormBuilder,
    public themeService: ThemeCustomizerService, 
  ) {
    this.itemsPerPage = this.adminService.ITEM_PERPAGE
    this.themeService.isToggled$.subscribe(isToggled => {
      this.isToggled = isToggled;
    });


  }

	

  toggleTheme() {
      this.themeService.toggleTheme();
  }


  ngOnInit(): void {

    this.createFilterForm()
    this.getLanguage()
    this.getBlogs()

  }


  getLanguage() {
    this.languages = this.adminService.getWebsiteLanguages()
  }


  onPageChange(page: number): void {
    this.currentPage = page;
    this.filter["page"] = page
    this.getBlogs();
  }


  createFilterForm() {
    this.filter_form = this.formBuilder.group({
      title: ["", Validators.pattern(/^[a-zA-Z0-9]*$/)],
      author: ["", Validators.pattern(/^[a-zA-Z0-9]*$/)],
      content_language: ['', Validators.pattern(/^[a-zA-Z0-9]*$/)],
    })
  }

  applyFilter() {
    if(this.filter_form.invalid) return 
    let lang = this.filter_form.get("content_language").value
    if (lang) {
      this.language = lang
    }
    const data = this.filter_form.value

    this.filter = {
      "title": data.title?data.title:"", 
      "author": data.author? data.author:"",
      "page": 1, 
      "lang": this.language
    }

    

    this.getBlogs()

    

  }

  resetFilter() {
    this.filter_form.reset()
    this.filter.title = ""
    this.filter.lang = 1
    this.filter.author = ""
    this.getBlogs()
  }
  getBlogs() {
    this.adminService.getRecordList(this.adminService.BLOG_URL, this.filter).subscribe({
      next: (res) => {
        this.blogs = res["data"]
        this.totalItems = res["total_records"]
        console.log("page", this.number_of_page)

      },
      error: (error) => {
        console.error("here goes the Unexpected error:", error);
      }
    })
  }
}
